import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDashboardData } from "./../features/cutomers/customerSlice";

const data1 = [];
for (let i = 0; i < 46; i++) {
  data1.push({
    key: i,
    name: `Edward King ${i}`,
    product: 32,
    staus: `London, Park Lane no. ${i}`,
  });
}
const Dashboard = () => {

  const dispatch = useDispatch();
  const { dashboardData } = useSelector((state) => state.customer);

  useEffect(() => {
    dispatch(getDashboardData());
  }, [dispatch]);

  return (
    <div>
      <h3 className="mb-4 title">Dashboard</h3>
      <div className="row g-3">
        {/* All cards in one row for desktop */}
        <div className="col-6 col-md-4 col-lg-2 mb-3">
          <div
            className="card bg-white p-3 shadow-sm"
            style={{ borderRadius: "15px", border:"1px solid #ffffff" }}
          >
            <div>
              <div className="d-flex justify-content-between align-items-center mb-1">
                <p
                  className="text-muted mb-0"
                  style={{ fontSize: "12px", color: "#888" }}
                >
                  Total Users
                </p>
                <img src="group.png" alt="" />
              </div>
              <h2
                className="mb-0 fw-bold"
                style={{ color: "#1a3c34", fontSize: "28px" }}
              >
                {dashboardData.user_count || 0}
              </h2>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-4 col-lg-2 mb-3">
          <div
            className="card bg-white p-3 shadow-sm"
            style={{ borderRadius: "15px", border:"1px solid #ffffff" }}
          >
            <div>
              <div className="d-flex justify-content-between align-items-center mb-1">
                <p
                  className="text-muted mb-0"
                  style={{ fontSize: "12px", color: "#888" }}
                >
                  Total User History
                </p>
                <img src="sports_golf.png" alt="" />
              </div>
              <h2
                className="mb-0 fw-bold"
                style={{ color: "#1a3c34", fontSize: "28px" }}
              >
                {dashboardData.all_user_count || 0}
              </h2>
            </div>
          </div>
        </div>

        <div className="col-6 col-md-4 col-lg-2 mb-3">
          <div
            className="card bg-white p-3 shadow-sm"
            style={{ borderRadius: "15px", border:"1px solid #ffffff" }}
          >
            <div>
              <div className="d-flex justify-content-between align-items-center mb-1">
                <p
                  className="text-muted mb-0"
                  style={{ fontSize: "12px", color: "#888" }}
                >
                  Daily Sign Ups
                </p>
                <img src="how_to_reg.png" alt="" />
              </div>
              <h2
                className="mb-0 fw-bold"
                style={{ color: "#1a3c34", fontSize: "28px" }}
              >
                {dashboardData.daily_sign_ups || 0}
              </h2>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-4 col-lg-2 mb-3">
          <div
            className="card bg-white p-3 shadow-sm"
            style={{ borderRadius: "15px", border:"1px solid #ffffff" }}
          >
            <div>
              <div className="d-flex justify-content-between align-items-center mb-1">
                <p
                  className="text-muted mb-0"
                  style={{ fontSize: "12px", color: "#888" }}
                >
                  Total Match
                </p>
                <img src="group.png" alt="" />
              </div>
              <h2
                className="mb-0 fw-bold"
                style={{ color: "#1a3c34", fontSize: "28px" }}
              >
                {dashboardData.matched_count || 0}
              </h2>
            </div>
          </div>
        </div>

        <div className="col-6 col-md-4 col-lg-2 mb-3">
          <div
            className="card bg-white p-3 shadow-sm"
            style={{ borderRadius: "15px", border:"1px solid #ffffff" }}
          >
            <div>
              <div className="d-flex justify-content-between align-items-center mb-1">
                <p
                  className="text-muted mb-0"
                  style={{ fontSize: "12px", color: "#888" }}
                >
                  Daily Transactions
                </p>
                <img src="currency_exchange.png" alt="" />
              </div>
              <h2
                className="mb-0 fw-bold"
                style={{ color: "#1a3c34", fontSize: "28px" }}
              >
                {dashboardData.daily_transactions || 0}
              </h2>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-4 col-lg-2 mb-3">
          <div
            className="card bg-white p-3 shadow-sm"
            style={{ borderRadius: "15px", border:"1px solid #ffffff" }}
          >
            <div>
              <div className="d-flex justify-content-between align-items-center mb-1">
                <p
                  className="text-muted mb-0"
                  style={{ fontSize: "12px", color: "#888" }}
                >
                  Daily Transactions
                </p>
                <img src="currency_exchange.png" alt="" />
              </div>
              <h2
                className="mb-0 fw-bold"
                style={{ color: "#1a3c34", fontSize: "28px" }}
              >
                {dashboardData.daily_transactions_amount || 0}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
